import { render, staticRenderFns } from "./OsvListActivity.vue?vue&type=template&id=a3e6b89c&"
import script from "./OsvListActivity.vue?vue&type=script&lang=js&"
export * from "./OsvListActivity.vue?vue&type=script&lang=js&"
import style0 from "./OsvListActivity.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports